import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
// dayjs locales are registered centrally in '@/shared/date/date.config'.
import { datetime } from '@/shared/date/date.config'
import { SUPPORTED_LANGUAGE_CODES, toLanguageCode } from '@/config/languages'

// Keep dayjs' global locale in sync with i18n, so localized date formats
// (L, LT, ll, lll, …) render in the user's language across the whole app
// (matches how moment's global locale behaved before the migration).
const syncDayjsLocale = (lng) => datetime.locale(toLanguageCode(lng))
i18n.on('languageChanged', syncDayjsLocale)

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'en',
    debug: false,
    lowerCaseLng: true,
    supportedLngs: [...SUPPORTED_LANGUAGE_CODES],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false
    }
  })
  .then(() => {
    const detectedLng = i18n.language
    const resolvedLng = toLanguageCode(detectedLng)
    if (resolvedLng !== detectedLng) {
      i18n.changeLanguage(resolvedLng)
    }
    // Sync dayjs on startup even when the language didn't change.
    syncDayjsLocale(resolvedLng)
  })

export default i18n
